<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAddNew" />
    <van-skeleton title :row="15" :loading="loadingPage || loadingReservePage">
      <van-tabs v-model="active">
        <van-tab title="近期行程">
          <div v-if="data && data.length<=0" class="emptyAbout" @click="onAddNew(0)">
            <i class="iconfont iconadd" /><br><br>
            立即预约
          </div>
          <div v-if="data && data.length > 0" class="fullAbout" @click="onAddNew(0)">
            继续预约其他近期行程<br>
          </div>
          <div v-for="(item,index) in data" :key="index" class="lineRect">
            <div class="dataRect">
              <van-row>
                <van-col span="12">队伍:<span :style="'color:'+GetColorMain()">{{ item.className }}</span></van-col>
                <van-col span="12">开始日期:<span :style="'color:'+GetColorMain()">{{ formatDate(item.beginDate,"yyyy/MM/dd") }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="12">带队教练:<span :style="'color:'+GetColorMain()">{{ item.cocahName }}</span></van-col>
                <van-col span="12">课程:<span :style="'color:'+GetColorMain()">{{ item.courseName }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="12">费用:<span :style="'color:'+GetColorMain()">CNY {{ ShowMoney(item.subscribe.price) }}</span></van-col>
                <van-col span="12">人数:<span :style="'color:'+GetColorMain()">{{ item.subscribe.count }} 位</span>
                </van-col>
              </van-row>
              <van-row v-if="item.autoCloseTick>0 && !item.subscribe.isPayFinish">
                <van-col span="12">订单关闭倒计时:
                  <span>
                    <van-count-down :style="'display: inline-block;color:'+GetColorMain()" :time="item.autoCloseTick" format="mm分 ss秒" />
                  </span>
                </van-col>
                <van-col span="12">状态:
                  <van-tag v-if="item.subscribe.isPayFinish" class="stateTag" type="primary" :color="GetColorMain()">已支付</van-tag>
                  <van-tag v-if="!item.subscribe.isPayFinish" class="stateTag" type="primary" :color="GetColorSecondary()">未支付</van-tag>
                  <van-tag v-if="item.subscribe.isReturnFinsih" class="stateTag" type="primary" :color="GetColorMain()">已退款</van-tag>
                </van-col>
              </van-row>
              <van-row v-if="item.subscribe.isPayFinish">
                <van-col span="12">订单支付时间:<span>{{ formatDate(item.subscribe.payTime,"yyyy/MM/dd hh:mm",true) }}</span></van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()" /></van-col>
              </van-row>
            </div>
            <van-row v-if="!item.subscribe.isPayFinish">
              <van-col span="12"><van-button type="primary" style="width:100%" :loading="buttonLoading" :color="GetColorSecondary()" size="small" @click="onCancelOrder(item.subscribe.subscribeId)">取消预定</van-button></van-col>
              <van-col span="12"><van-button type="primary" style="width:100%" :loading="buttonLoading" :color="GetColorMain()" size="small" @click="onPayOrder(item.subscribe.moneyId)">立即支付</van-button></van-col>
            </van-row>
            <van-row v-if="item.subscribe.isPayFinish && !item.subscribe.isReturnFinsih">
              <van-col span="24"><van-button type="primary" style="width:100%" :loading="buttonLoading" :color="GetColorMain()" size="small" @click="onViewDiveOrder(item.subscribe.diveOrderId)">查看行程订单</van-button></van-col>
            </van-row>
          </div>
        </van-tab>
        <van-tab title="待组队行程">
          <div v-if="dataReserve && dataReserve.length<=0" class="emptyAbout" @click="onAddNew(1)">
            <i class="iconfont iconadd" /><br><br>
            立即添加
          </div>
          <div v-if="dataReserve && dataReserve.length > 0" class="fullAbout" @click="onAddNew(1)">
            继续添加其他行程
          </div>
          <div v-for="item in dataReserve" :key="item.reserve.reserveId" class="lineRect">
            <div class="dataRect">
              <van-row>
                <van-col span="12">行程:<span :style="'color:'+GetColorMain()">{{ item.product.cityName }} {{ item.product.className }}</span></van-col>
                <van-col span="12">出行日期:<span :style="'color:'+GetColorMain()">{{ formatDate(item.reserve.startDate,"yyyy/MM/dd") }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="12">最大人数:<span :style="'color:'+GetColorMain()">{{ item.reserve.maxPerson }}</span></van-col>
                <van-col span="12">最低人数:<span :style="'color:'+GetColorMain()">{{ item.reserve.minPerson }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="12">队伍状态:<span :style="'color:'+GetColorMain()">{{ GetEnumText('Em_MemberCardReserveType',item.reserve.state) }}</span></van-col>
                <van-col span="12">当前人数:<span :style="'color:'+GetColorMain()">{{ item.reserve.personNow }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="24">组队确认时间:<span>
                  <van-count-down
                    v-if="item.teamConfirmTime>0"
                    :style="'display: inline-block;font-size: 0.8em;color:'+GetColorMain()"
                    :time="item.teamConfirmTime"
                    format="DD天HH时mm分"
                  />
                  <template v-if="item.teamConfirmTime<=0">即将结束</template>
                </span>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="24">备注:<span :style="'color:'+GetColorMain()">{{ item.product.reamrk }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="24">说明:<span :style="'color:'+GetColorMain()">{{ item.product.about }}</span></van-col>
              </van-row>
              <van-row>
                <van-col span="12">费用:<span :style="'color:'+GetColorMain()">CNY {{ ShowMoney(item.reserve.priceOne) }}</span></van-col>
                <van-col span="12">支付状态:
                  <van-tag v-if="item.user.isPayFinish" class="stateTag" type="primary" :color="GetColorMain()">已支付</van-tag>
                  <van-tag v-if="!item.user.isPayFinish" class="stateTag" type="primary" :color="GetColorSecondary()">未支付</van-tag>
                  <van-tag v-if="item.user.isReturnFinsih" class="stateTag" type="primary" :color="GetColorMain()">已退款</van-tag>
                </van-col>
              </van-row>

              <van-row v-if="item.autoCloseTick>0 && !item.user.isPayFinish">
                <van-col span="12">订单关闭倒计时:
                  <span>
                    <van-count-down :style="'display: inline-block;color:'+GetColorMain()" :time="item.autoCloseTick" format="mm分 ss秒" />
                  </span>
                </van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()" /></van-col>
              </van-row>
              <van-row v-if="item.user.isPayFinish">
                <van-col span="12">订单支付时间:<span>{{ formatDate(item.user.payTime,"yyyy/MM/dd hh:mm",true) }}</span></van-col>
                <van-col span="12"><span :style="'color:'+GetColorMain()" /></van-col>
              </van-row>
            </div>
            <van-row v-if="!item.user.isPayFinish">
              <van-col span="12"><van-button type="primary" style="width:100%" :loading="buttonLoading" :color="GetColorSecondary()" size="small" @click="onCancelReserveOrder(item.user.reserveUserId)">取消预定</van-button></van-col>
              <van-col span="12"><van-button type="primary" style="width:100%" :loading="buttonLoading" :color="GetColorMain()" size="small" @click="onPayOrder(item.user.moneyId)">立即支付</van-button></van-col>
            </van-row>
            <van-row v-if="item.user.diveOrderId">
              <van-col span="24"><van-button type="primary" style="width:100%;margin-top:0.5em;" :loading="buttonLoading" :color="GetColorMain()" size="small" @click="onViewDiveOrder(item.user.diveOrderId)">查看行程订单</van-button></van-col>
            </van-row>
            <van-row v-if="item.reserve.state==='CREATE'">
              <van-col span="24"><van-button type="primary" style="width:100%;margin-top:0.5em;" :color="GetColorMain()" size="small" @click="onShare(item)">邀请好友一同加入行程</van-button></van-col>
            </van-row>
          </div>
        </van-tab>
      </van-tabs>

    </van-skeleton>
    <van-popup v-model="showSharePopup" position="bottom">
      <van-row class="popTitle">
        <van-col span="4" />
        <van-col span="16" class="center" :style="'color:'+GetColorMain()">分享海报</van-col>
        <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showSharePopup=false" /></van-col>
      </van-row>
      <div class="sharePageRect">
        <van-image
          width="100vw"
          height="100vh"
          lazy-load
          :src="shareAdUrl"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, Tag, CountDown, Dialog, Tab, Tabs, Popup, Image } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetServiceUrlBase } from '@/utils/request'

export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Tag.name]: Tag,
    [CountDown.name]: CountDown,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Image.name]: Image,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '行程预约列表',
      backurl: '/store/index',
      itemId: undefined,
      hashCode: undefined,
      loadingPage: true,
      loadingReservePage: true,
      data: [],
      dataReserve: [],
      buttonLoading: false,
      active: 0,
      showSharePopup: false,
      shareAdUrl: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.itemId = getUrlKey('itemId')
    this.hashCode = getUrlKey('hashCode')
    this.init()
    this.initReserveList()
  },
  methods: {
    GetServiceUrlBase,
    MyNotify,
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loadingPage = true
      request({
        url: '/MemberCard/getMemberCardSubscribeBookList',
        method: 'post',
        params: { hashCode: this.hashCode,
          id: this.itemId }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.data = response.data
      })
    },
    initReserveList() {
      this.loadingReservePage = true
      request({
        url: '/MemberCard/getMemberCardReserveBookList',
        method: 'post',
        params: { hashCode: this.hashCode,
          id: this.itemId }
      }).then(response => {
        this.loadingReservePage = false
        if (!response.success) {
          return
        }
        this.dataReserve = response.data
      })
    },
    onAddNew(tab) {
      this.$router.push('/memberCard/subscribe?itemId=' + this.itemId + '&hashCode=' + this.hashCode + '&tab=' + tab)
    },
    onCancelOrder(subscribeId) {
      Dialog.confirm({
        title: '取消预约',
        message: '请确定是否要取消预约?'
      }).then(() => {
        this.onCancelOrderDo(subscribeId)
      })
    },
    onCancelOrderDo(subscribeId) {
      this.buttonLoading = true
      request({
        url: '/MemberCard/cancelMemberCardSubscribe',
        method: 'post',
        params: { id: subscribeId }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '预约取消成功')
        this.init()
      })
    },
    onCancelReserveOrder(reserveUserId) {
      Dialog.confirm({
        title: '取消预约',
        message: '请确定是否要取消预约?'
      }).then(() => {
        this.onCancelReserveOrderDo(reserveUserId)
      })
    },
    onCancelReserveOrderDo(reserveUserId) {
      this.buttonLoading = true
      request({
        url: '/MemberCard/cancelMemberCardReserve',
        method: 'post',
        params: { id: reserveUserId }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '预约取消成功')
        this.initReserveList()
      })
    },
    onPayOrder(moneyId) {
      this.$router.push('/store/pay/0?id=' + moneyId)
    },
    onViewDiveOrder(studentId) {
      this.$router.push('/divetrip')
    },
    onShare(item) {
      this.showSharePopup = true
      this.shareAdUrl = GetServiceUrlBase() + '/userapi/image/getMemberCardShareAd?' +
        'date=' + formatDate(item.reserve.startDate, 'yyyy/MM/dd') +
        '&name=' + item.shareName +
        '&title=' + item.shareTitle +
        '&type' + item.shareType
    }
  }
}
</script>
<style scoped>
.popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}
.sharePageRect{
  width: 100vw;
  height: 90vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.lineRect{
 background-color: #fff;
 overflow: hidden;
 margin: 1em 1em;
 border-radius: 0.4em;
 font-size: 0.8em;
 line-height: 1.8em;
}
.lineRect .dataRect{
  padding: 1em;
}
.emptyAbout{
  color:#999;
  font-size: 0.8em;
  text-align: center;
  padding: 30vh 0;
}
.emptyAbout i{
  font-size:8em;
  color:#cacaca;
}
.fullAbout{
  color:#999;
  font-size: 0.8em;
  text-align: center;
  background-color: #fff;
  overflow: hidden;
  margin: 1em 1em;
  border-radius: 0.4em;
  font-size: 0.8em;
  line-height: 6em;
}
.stateTag{
  margin-right: 0.5em;
}
</style>
